import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export function createAxiosInstance(baseURL?: string, customConfig?: AxiosRequestConfig) {
  return axios.create({
    baseURL,
    ...customConfig
  });
}
